import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Wrench, Paintbrush, ShieldCheck, CircleDot, Sparkles, MessageCircle, ShoppingCart, Disc, Search } from 'lucide-react';
import { services, contactInfo } from '../mockData';

const iconMap = {
  Wrench: Wrench,
  Paintbrush: Paintbrush,
  ShieldCheck: ShieldCheck,
  CircleDot: CircleDot,
  Sparkles: Sparkles,
  MessageCircle: MessageCircle,
  ShoppingCart: ShoppingCart,
  Disc: Disc,
  Search: Search
};

const Services = () => {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="services-hero-content fade-in">
            <h1 className="page-title">
              Nos <span className="text-yellow">Services</span><br />
              Premium
            </h1>
            <p className="page-subtitle">
              Une expertise complète en carrosserie, peinture et rénovation automobile. 
              NDV Motors met son savoir-faire à votre service pour redonner à votre véhicule 
              toute sa splendeur.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-content section-padding">
        <div className="container">
          <div className="services-list">
            {services.map((service, index) => {
              const IconComponent = iconMap[service.icon];
              const isEven = index % 2 === 0;
              
              return (
                <div
                  key={service.id}
                  className={`service-detail-card fade-in ${isEven ? 'slide-in-left' : 'slide-in-right'}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className={`service-detail-grid ${isEven ? '' : 'reverse'}`}>
                    <div className="service-detail-image">
                      <img src={service.image} alt={service.title} />
                      <div className="service-detail-overlay"></div>
                      <div className="service-icon-badge">
                        {IconComponent && <IconComponent size={40} />}
                      </div>
                    </div>
                    <div className="service-detail-content">
                      <h2 className="service-detail-title">{service.title}</h2>
                      <p className="service-detail-description">{service.description}</p>
                      <ul className="service-features">
                        {service.id === 1 && (
                          <>
                            <li>Achat de véhicules d'occasion</li>
                            <li>Vente de véhicules toutes marques</li>
                            <li>Reprise de votre ancien véhicule</li>
                            <li>Conseil personnalisé</li>
                          </>
                        )}
                        {service.id === 2 && (
                          <>
                            <li>Vidange et entretien moteur</li>
                            <li>Remplacement distribution</li>
                            <li>Freinage et embrayage</li>
                            <li>Diagnostic et réparation</li>
                          </>
                        )}
                        {service.id === 3 && (
                          <>
                            <li>Réparation carrosserie complète</li>
                            <li>Débosselage et redressage</li>
                            <li>Peinture en cabine professionnelle</li>
                            <li>Finitions haut de gamme</li>
                          </>
                        )}
                        {service.id === 4 && (
                          <>
                            <li>Ponçage et préparation</li>
                            <li>Redressage de jantes</li>
                            <li>Peinture et vernissage</li>
                            <li>Polissage et finition</li>
                          </>
                        )}
                        {service.id === 5 && (
                          <>
                            <li>Vente pneus toutes marques</li>
                            <li>Montage et équilibrage</li>
                            <li>Géométrie des trains</li>
                            <li>Conseil personnalisé</li>
                          </>
                        )}
                        {service.id === 6 && (
                          <>
                            <li>Nettoyage intérieur/extérieur</li>
                            <li>Polissage et lustrage</li>
                            <li>Traitement céramique</li>
                            <li>Rénovation optiques</li>
                          </>
                        )}
                        {service.id === 7 && (
                          <>
                            <li>Diagnostic électronique complet</li>
                            <li>Lecture codes défauts</li>
                            <li>Effacement codes erreur</li>
                            <li>Valise professionnelle</li>
                          </>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section section-padding">
        <div className="container">
          <div className="section-header text-center mb-60">
            <h2 className="section-title">
              Pourquoi Choisir <span className="text-yellow">NDV Motors</span> ?
            </h2>
          </div>
          <div className="why-choose-grid">
            <div className="why-card fade-in">
              <div className="why-icon">
                <Wrench size={48} />
              </div>
              <h3 className="why-title">Équipement Professionnel</h3>
              <p className="why-text">
                Cabine de peinture dernière génération et équipements à la pointe de la technologie.
              </p>
            </div>
            <div className="why-card fade-in" style={{ animationDelay: '0.1s' }}>
              <div className="why-icon">
                <ShieldCheck size={48} />
              </div>
              <h3 className="why-title">Qualité Garantie</h3>
              <p className="why-text">
                Travail soigné avec des finitions parfaites. Votre satisfaction est notre priorité.
              </p>
            </div>
            <div className="why-card fade-in" style={{ animationDelay: '0.2s' }}>
              <div className="why-icon">
                <Sparkles size={48} />
              </div>
              <h3 className="why-title">Expertise Premium</h3>
              <p className="why-text">
                Plus de 10 ans d'expérience au service de l'excellence automobile.
              </p>
            </div>
            <div className="why-card fade-in" style={{ animationDelay: '0.3s' }}>
              <div className="why-icon">
                <MessageCircle size={48} />
              </div>
              <h3 className="why-title">Service Personnalisé</h3>
              <p className="why-text">
                Accompagnement sur mesure et conseils adaptés à vos besoins spécifiques.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta section-padding">
        <div className="container">
          <div className="services-cta-content">
            <h2 className="cta-title fade-in">
              Besoin d'un Service Automobile ?
            </h2>
            <p className="cta-subtitle slide-in-left">
              Contactez-nous pour un devis gratuit et personnalisé
            </p>
            <div className="cta-buttons slide-in-right">
              <Link to="/contact" className="btn-primary">
                Demander un Devis
                <ArrowRight size={20} />
              </Link>
              <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="btn-secondary">
                Appeler Maintenant
              </a>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        /* Hero Section */
        .services-hero {
          background: linear-gradient(135deg, var(--bg-page) 0%, var(--bg-card) 100%);
          padding: 160px 40px 80px;
          border-bottom: 3px solid var(--brand-yellow);
        }

        .services-hero-content {
          max-width: 900px;
          margin: 0 auto;
          text-align: center;
        }

        .page-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(2.5rem, 6vw, 5rem);
          line-height: 1.1;
          color: var(--text-primary);
          margin-bottom: 24px;
        }

        .page-subtitle {
          font-size: clamp(1rem, 2vw, 1.3rem);
          line-height: 1.7;
          color: var(--text-secondary);
          max-width: 700px;
          margin: 0 auto;
        }

        /* Services Content */
        .services-list {
          display: flex;
          flex-direction: column;
          gap: 60px;
        }

        .service-detail-card {
          background: var(--bg-card);
          border-radius: var(--radius-lg);
          overflow: hidden;
          border: 2px solid var(--border-light);
          transition: all 0.3s ease;
        }

        .service-detail-card:hover {
          border-color: var(--brand-yellow);
          box-shadow: 0 15px 40px rgba(255, 193, 7, 0.15);
        }

        .service-detail-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0;
          min-height: 450px;
        }

        .service-detail-grid.reverse {
          direction: rtl;
        }

        .service-detail-grid.reverse > * {
          direction: ltr;
        }

        .service-detail-image {
          position: relative;
          overflow: hidden;
        }

        .service-detail-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .service-detail-card:hover .service-detail-image img {
          transform: scale(1.1);
        }

        .service-detail-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.6) 0%, rgba(255, 193, 7, 0.1) 100%);
        }

        .service-icon-badge {
          position: absolute;
          top: 24px;
          right: 24px;
          background: var(--brand-yellow);
          color: var(--brand-black);
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 20px rgba(255, 193, 7, 0.4);
        }

        .service-detail-content {
          padding: 48px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .service-detail-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 800;
          font-size: 2rem;
          color: var(--brand-yellow);
          margin-bottom: 20px;
        }

        .service-detail-description {
          font-size: 1.1rem;
          line-height: 1.7;
          color: var(--text-secondary);
          margin-bottom: 28px;
        }

        .service-features {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .service-features li {
          font-size: 1rem;
          color: var(--text-primary);
          padding-left: 28px;
          position: relative;
        }

        .service-features li::before {
          content: '▶';
          position: absolute;
          left: 0;
          color: var(--brand-yellow);
          font-size: 0.8rem;
        }

        /* Why Choose Section */
        .why-choose-section {
          background: var(--bg-page);
        }

        .why-choose-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 32px;
        }

        .why-card {
          background: var(--bg-card);
          padding: 40px 32px;
          border-radius: var(--radius-lg);
          border: 2px solid var(--border-light);
          text-align: center;
          transition: all 0.3s ease;
        }

        .why-card:hover {
          border-color: var(--brand-yellow);
          transform: translateY(-8px);
          box-shadow: 0 10px 30px rgba(255, 193, 7, 0.2);
        }

        .why-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100px;
          height: 100px;
          margin: 0 auto 24px;
          background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-dark) 100%);
          color: var(--brand-black);
          border-radius: 50%;
          transition: transform 0.3s ease;
        }

        .why-card:hover .why-icon {
          transform: scale(1.1) rotate(5deg);
        }

        .why-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 700;
          font-size: 1.4rem;
          color: var(--brand-yellow);
          margin-bottom: 16px;
        }

        .why-text {
          font-size: 1rem;
          line-height: 1.6;
          color: var(--text-secondary);
        }

        /* CTA Section */
        .services-cta {
          background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-dark) 100%);
        }

        .services-cta-content {
          text-align: center;
          max-width: 800px;
          margin: 0 auto;
        }

        .cta-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(2rem, 4vw, 3.5rem);
          color: var(--brand-black);
          margin-bottom: 20px;
        }

        .cta-subtitle {
          font-size: 1.3rem;
          color: var(--brand-black);
          margin-bottom: 40px;
          opacity: 0.9;
        }

        .cta-buttons {
          display: flex;
          gap: 20px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .services-cta .btn-primary {
          background: var(--brand-black);
          color: var(--brand-yellow);
        }

        .services-cta .btn-primary:hover {
          background: var(--brand-black-light);
        }

        .services-cta .btn-secondary {
          background: transparent;
          color: var(--brand-black);
          border-color: var(--brand-black);
        }

        .services-cta .btn-secondary:hover {
          background: var(--brand-black);
          color: var(--brand-yellow);
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .service-detail-grid {
            grid-template-columns: 1fr;
          }

          .service-detail-grid.reverse {
            direction: ltr;
          }

          .service-detail-image {
            min-height: 350px;
          }

          .service-detail-content {
            padding: 32px;
          }
        }

        @media (max-width: 767px) {
          .services-hero {
            padding: 120px 20px 60px;
          }

          .service-detail-content {
            padding: 24px;
          }

          .service-icon-badge {
            width: 60px;
            height: 60px;
            top: 16px;
            right: 16px;
          }

          .service-icon-badge svg {
            width: 28px;
            height: 28px;
          }

          .why-choose-grid {
            grid-template-columns: 1fr;
          }

          .cta-buttons {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default Services;
